import { Add, ArrowRight2 } from 'iconsax-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Loader } from '@/components/Loader/Loader'
import { Button } from '@/components/ui/button'
import { Separator } from '@/components/ui/separator'
import { AppRoutes } from '@/constants/appRoutes'
import { useGetAccountStatsQuery } from '@/store/api/Account/Account.query'
import { selectCreditsFromStore } from '@/store/api/Users/Users.selector'
import { SocialMirrorPalette } from '@/utils/palette/SocialMirrorPalette'

interface ReportCardProps {
  isProUser: boolean
}

export const ReportCard = ({ isProUser }: ReportCardProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data: stats, isLoading } = useGetAccountStatsQuery()
  const credits = useSelector(selectCreditsFromStore)
  const cantRunReport = credits === 0
  return (
    <div className="flex flex-col gap-5 w-1/2 bg-baseColorHighlight rounded-2xl p-4 max-md:w-full max-lg:w-3/4">
      <div className="flex flex-col gap-1">
        {isLoading ? (
          <div className="w-7 h-7">
            <Loader />
          </div>
        ) : (
          <p
            className={`text-xl font-medium ${
              !cantRunReport ? 'text-neutralColor' : 'text-neutralColor30'
            }`}
          >
            {stats?.info?.completedReports || 0}
          </p>
        )}
        <p
          className={`text-sm font-normal ${
            !cantRunReport ? 'text-neutralColor' : 'text-neutralColor30'
          }`}
        >
          {!cantRunReport
            ? t('dashboard.home.reportCard.reportsCompleted')
            : t('dashboard.home.reportCard.notCheckedYet')}
        </p>
      </div>
      <Separator className="bg-neutralColor30 h-[0.5px]" />

      <div className="flex gap-4 items-center  max-md:flex-col">
        <Button
          className="w-full rounded-3xl h-11 text-base font-medium justify-between border-neutralColor30"
          variant="outline"
          disabled={cantRunReport}
          onClick={() => {
            navigate(AppRoutes.editDigitalFootprint)
          }}
        >
          {t('dashboard.home.reportCard.editSocialMirrorProfile')}
          <ArrowRight2 size="20" color={SocialMirrorPalette.neutralColor} />
        </Button>
        <Button
          className="w-full rounded-3xl h-11 text-base font-medium justify-between border-neutralColor30"
          variant="default"
          disabled={cantRunReport}
          onClick={() => {
            navigate(AppRoutes.confirmSearchInfo)
          }}
        >
          {t('dashboard.home.reportCard.newReport')}
          <Add size="20" color={SocialMirrorPalette.neutralColor} />
        </Button>
      </div>
    </div>
  )
}
